// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { BiSave, BiKey, BiLock, BiShow, BiHide, BiCreditCard } from 'react-icons/bi';
// import { API_BASE_URL } from '../utils/urls.js';
// import axiosClient from "../utils/apiClient.js";
// import { toast } from 'react-toastify';

// const UserForm = ({ isNew = false }) => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const [formData, setFormData] = useState({
//         first_name: '',
//         last_name: '',
//         email: '',
//         phone_number: '',
//         organization:'',
//         role_id: ''
//     });
//     const [passwordData, setPasswordData] = useState({
//         current_password: '',
//         new_password: '',
//         confirm_new_password: ''
//     });
//     const [adminPasswordData, setAdminPasswordData] = useState({
//         new_password: '',
//         confirm_new_password: ''
//     });
//     const [roles, setRoles] = useState([]);
//     const [message, setMessage] = useState(null);
//     const [isSaving, setIsSaving] = useState(false);
//     const [isPasswordChanging, setIsPasswordChanging] = useState(false);
//     const [isAdminPasswordChanging, setIsAdminPasswordChanging] = useState(false);
//     const [isPasswordFormOpen, setIsPasswordFormOpen] = useState(false);
//     const [isAdminPasswordFormOpen, setIsAdminPasswordFormOpen] = useState(false);
//     const user = JSON.parse(localStorage.getItem('user'));
//     const [showPassword, setShowPassword] = useState(false);
//     const [stripeConnected, setStripeConnected] = useState(false);
//     const [stripeConnectedId, setStripeConnectedId] = useState("");

//     const stripeAccountId = localStorage.getItem('stripeAccountId');
//     if(stripeAccountId){
//         if(!stripeConnectedId){

//             setStripeConnected(true);
//             setStripeConnectedId(stripeAccountId);
//         }
//     }

//     console.log("User form", user)
//     useEffect(() => {
//         const fetchUserDataAndRoles = async () => {
//             try {
//                 const token = localStorage.getItem('token');
//                 let userData = {};

//                 // Step 1: Fetch user data only if we are editing and an ID is available
//                 if (!isNew && id) {
//                     const userResponse = await axios.get(`${API_BASE_URL}/users/${id}`, {
//                         headers: { Authorization: `Bearer ${token}` }
//                     });
//                     userData = userResponse.data;
//                 }

//                 // Step 2: Fetch roles list (for admin)
//                 if (user?.roleName === 'admin') {
//                     const rolesResponse = await axios.get(API_BASE_URL + '/users/roles', {
//                         headers: { Authorization: `Bearer ${token}` }
//                     });
//                     setRoles(rolesResponse.data);
//                 }

//                 // Step 3: Set form data after fetching is complete
//                 setFormData(prevState => ({
//                     ...prevState,
//                     ...userData,
//                     role_id: userData.role_id || ''
//                 }));

//             } catch (error) {
//                 toast.error('Error fetching data. Please check your network and permissions.');
//                 console.error('Error fetching data:', error);
//             }
//         };

//         // Redirect to login if user is not authenticated when trying to edit
//         if (!isNew && !user) {
//             navigate('/login');
//             return;
//         }

//         fetchUserDataAndRoles();
//     }, [id, isNew, user?.roleName, navigate]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleStripeConnect = async () => {
//         try {
//             const token = localStorage.getItem("token");

//             const res = await axiosClient.get(`/stripe/connect`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`
//                 }
//             });



//             if (res.data?.url) {
//                 window.location.href = res.data.url; // Redirect to Stripe Connect
//             } else {
//                 toast.error("Unable to start Stripe connection.");
//             }
//         } catch (err) {
//             console.error("Stripe connect error:", err);
//             toast.error("Failed to connect Stripe account.");
//         }
//     };

//     const handlePasswordChange = (e) => {
//         setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
//     };

//     const handleAdminPasswordChange = (e) => {
//         setAdminPasswordData({ ...adminPasswordData, [e.target.name]: e.target.value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsSaving(true);
//         setMessage(null);
//         try {
//             const token = localStorage.getItem('token');
//             if (isNew) {
//                 const dataToSubmit = { ...formData };
//                 await axios.post(API_BASE_URL + '/users/create', dataToSubmit, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });
//                 navigate('/users');
//             } else {
//                 await axios.put(`${API_BASE_URL}/users/${id}`, formData, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });
//                 toast.success('Profile updated successfully.');
//             }
//         } catch (error) {
//             toast.error('Failed to save user data.');
//             console.error('Error saving user data:', error);
//         } finally {
//             setIsSaving(false);
//         }
//     };

//     const handlePasswordSubmit = async (e) => {
//         e.preventDefault();
//         setIsPasswordChanging(true);
//         setMessage(null);
//         if (passwordData.new_password !== passwordData.confirm_new_password) {
//             toast.error('New passwords do not match.');
//             setIsPasswordChanging(false);
//             return;
//         }
//         try {
//             const token = localStorage.getItem('token');
//             // Check if user object exists before accessing its properties
//             if (!user) {
//                 throw new Error("User not authenticated.");
//             }
//             if (user.isContactLogin) {
//                 await axios.put(`${API_BASE_URL}/users/contact/change-password/${user.contactId}`, passwordData, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });
//                 setMessage('Password updated successfully.');
//                 setPasswordData({ current_password: '', new_password: '', confirm_new_password: '' });
//                 setIsPasswordFormOpen(false);
//             } else {
//                 await axios.put(`${API_BASE_URL}/users/change-password/${user.id}`, passwordData, {
//                     headers: { Authorization: `Bearer ${token}` }
//                 });
//                 toast.success('Password updated successfully.');
//                 setPasswordData({ current_password: '', new_password: '', confirm_new_password: '' });
//                 setIsPasswordFormOpen(false);
//             }
//         } catch (error) {
//             toast.error(error.response?.data?.message || 'Failed to change password.');
//             console.error('Error changing password:', error);
//         } finally {
//             setIsPasswordChanging(false);
//         }
//     };

//     const handleAdminPasswordSubmit = async (e) => {
//         e.preventDefault();
//         setIsAdminPasswordChanging(true);
//         setMessage(null);
//         if (adminPasswordData.new_password !== adminPasswordData.confirm_new_password) {
//             toast.error('New passwords do not match.');
//             setIsAdminPasswordChanging(false);
//             return;
//         }
//         try {
//             const token = localStorage.getItem('token');
//             await axios.put(`${API_BASE_URL}/users/reset-password/${id}`, { new_password: adminPasswordData.new_password }, {
//                 headers: { Authorization: `Bearer ${token}` }
//             });
//             toast.success('Password updated successfully by admin.');
//             setAdminPasswordData({ new_password: '', confirm_new_password: '' });
//             setIsAdminPasswordFormOpen(false);
//         } catch (error) {
//             toast.error(error.response?.data?.message || 'Failed to reset password.');
//             console.error('Error resetting password:', error);
//         } finally {
//             setIsAdminPasswordChanging(false);
//         }
//     };

//     // Fix: Only run this check if `id` is not undefined
//     const isSelfEdit = id && user && parseInt(id) === user.id;

//     return (
//         <div className="container mx-auto p-4">
//             <h1 className="text-3xl font-bold text-gray-800 mb-6">
//                 {isNew ? 'Create New User' : 'Edit User Profile'}
//             </h1>
//             {message && (
//                 <div className={`p-3 rounded-md mb-4 ${message.includes('successfully') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
//                     {message}
//                 </div>
//             )}

//             <div className="bg-white shadow-lg rounded-lg p-6 mb-6">
//                 <h2 className="text-xl font-semibold mb-4">User Details</h2>
//                 <form onSubmit={handleSubmit}>
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700">First Name</label>
//                             <input type="text" name="first_name" value={formData.first_name || user.firstName} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700">Last Name</label>
//                             <input type="text" name="last_name" value={formData.last_name || user.lastName} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                         </div>
//                         {
//                             user.roleName == "admin" &&(
//                             <div>
//                                 <label className="block text-sm font-medium text-gray-700">{user.roleName == "admin" ? 'Organization' : "Agency"}</label>
//                                 <input type="text" name="organization" value={formData.organization} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                             </div>
//                             )
//                         }

//                         <div>
//                             <label className="block text-sm font-medium text-gray-700">Email</label>
//                             <input type="email" name="email" value={user.isContactLogin ? user.email : formData.email} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                         </div>
//                         <div>
//                             <label className="block text-sm font-medium text-gray-700">{user.isContactLogin ? "Agency Phone" : "Phone"}</label>
//                             <input type="text" name="phone_number" value={formData.phone_number} onChange={handleChange} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                         </div>
//                         {user?.roleName === 'admin' && (
//                             <div>
//                                 <label className="block text-sm font-medium text-gray-700">Role</label>
//                                 <select name="role_id" value={formData.role_id || ''} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2">
//                                     <option value="">Select a role</option>
//                                     {roles.map(role => (
//                                         <option key={role.id} value={role.id}>
//                                             {role.role_name.replace('_', ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
//                                         </option>
//                                     ))}
//                                 </select>
//                             </div>

//                         )}
//                         {user?.roleName === 'admin' && (
//                             <div className="relative">
//                                 <label className="block text-sm font-medium text-gray-700">Password</label>

//                                 <input
//                                     type={showPassword ? "text" : "password"}
//                                     name="password"
//                                     value={formData.password}
//                                     onChange={handleChange}
//                                     className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2 pr-10"
//                                 />

//                                 <button
//                                     type="button"
//                                     onClick={() => setShowPassword(!showPassword)}
//                                     className="absolute right-3 top-[35px] text-gray-500 hover:text-gray-700 focus:outline-none"
//                                 >
//                                     {showPassword ? <BiHide size={20} /> : <BiShow size={20} />}
//                                 </button>
//                             </div>
//                         )}
//                     </div>

//                     {!user.isContactLogin && (
//                         <div className="flex justify-end space-x-4">
//                             <button type="button" onClick={() => navigate(-1)} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
//                                 Cancel
//                             </button>
//                             <button type="submit" disabled={isSaving} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
//                                 <BiSave className="mr-2" /> {isSaving ? 'Saving...' : 'Save Changes'}
//                             </button>
//                         </div>
//                     )}
//                 </form>
//             </div>

//             {/* Admin password reset form */}
//             {user?.roleName === 'admin' && !isNew && (
//                 <div className="bg-white shadow-lg rounded-lg p-6 mt-6">
//                     <div className="flex justify-between items-center mb-4">
//                         <h2 className="text-xl font-semibold">Admin Password Reset</h2>
//                         <button onClick={() => setIsAdminPasswordFormOpen(!isAdminPasswordFormOpen)} className="text-blue-600 hover:text-blue-800 transition">
//                             {isAdminPasswordFormOpen ? 'Close' : 'Reset Password'}
//                         </button>
//                     </div>
//                     {isAdminPasswordFormOpen && (
//                         <form onSubmit={handleAdminPasswordSubmit}>
//                             <div className="space-y-4">
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700">New Password</label>
//                                     <input type="password" name="new_password" value={adminPasswordData.new_password} onChange={handleAdminPasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                                 </div>
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700">Confirm New Password</label>
//                                     <input type="password" name="confirm_new_password" value={adminPasswordData.confirm_new_password} onChange={handleAdminPasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                                 </div>
//                             </div>
//                             <div className="flex justify-end mt-4">
//                                 <button type="submit" disabled={isAdminPasswordChanging} className="flex items-center px-4 py-2 bg-red-600 text-white rounded-md text-sm font-medium hover:bg-red-700 disabled:opacity-50">
//                                     <BiLock className="mr-2" /> {isAdminPasswordChanging ? 'Resetting...' : 'Reset Password'}
//                                 </button>
//                             </div>
//                         </form>
//                     )}
//                 </div>
//             )}

//             {/* Password change form for the user themselves */}
//             {isSelfEdit && (
//                 <div className="bg-white shadow-lg rounded-lg p-6 mt-6">
//                     <div className="flex justify-between items-center mb-4">
//                         <h2 className="text-xl font-semibold">Change Password</h2>
//                         <button onClick={() => setIsPasswordFormOpen(!isPasswordFormOpen)} className="text-blue-600 hover:text-blue-800 transition">
//                             {isPasswordFormOpen ? 'Close' : 'Change Password'}
//                         </button>
//                     </div>
//                     {isPasswordFormOpen && (
//                         <form onSubmit={handlePasswordSubmit}>
//                             <div className="space-y-4">
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700">Current Password</label>
//                                     <input type="password" name="current_password" value={passwordData.current_password} onChange={handlePasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                                 </div>
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700">New Password</label>
//                                     <input type="password" name="new_password" value={passwordData.new_password} onChange={handlePasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                                 </div>
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700">Confirm New Password</label>
//                                     <input type="password" name="confirm_new_password" value={passwordData.confirm_new_password} onChange={handlePasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-1.5 mt-2" />
//                                 </div>
//                             </div>
//                             <div className="flex justify-end mt-4">
//                                 <button type="submit" disabled={isPasswordChanging} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
//                                     <BiKey className="mr-2" /> {isPasswordChanging ? 'Updating...' : 'Update Password'}
//                                 </button>
//                             </div>
//                         </form>
//                     )}
//                 </div>
//             )}


//             {/* Admin Stripe Connect */}
//             {user?.roleName === 'admin' && (
                      
//                         <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg shadow-sm flex justify-between items-center mt-6">
//                           <div>
//                             <p className="text-blue-800 font-semibold">Stripe Connect</p>
//                             <p className="text-sm text-blue-600">
//                               {stripeConnected ? "Stripe Account (Connected): " + stripeConnectedId : "Connect your Stripe account to receive invoice payments." } 
//                             </p>
//                           </div>
                
//                           <button
//                             onClick={handleStripeConnect}
//                             className="flex items-center bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-indigo-700 transition"
//                           >
//                             <BiCreditCard className="mr-2 h-5 w-5" />
//                             {stripeConnected ? "Change Stripe Account" : "Connect Stripe"}
//                           </button>
//                         </div>
                      
//             )}
//         </div>
//     );
// };

// export default UserForm;


import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BiSave, BiKey, BiLock, BiShow, BiHide, BiCreditCard, BiImageAdd } from 'react-icons/bi';
import { API_BASE_URL } from '../utils/urls.js';
import axiosClient from "../utils/apiClient.js";
import { toast } from 'react-toastify';

const UserForm = ({ isNew = false }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        organization: '',
        org_address: '', // New Organization Address Field
        role_id: ''
    });
    const [logoFile, setLogoFile] = useState(null); // New Logo File State

    const [passwordData, setPasswordData] = useState({
        current_password: '',
        new_password: '',
        confirm_new_password: ''
    });
    const [adminPasswordData, setAdminPasswordData] = useState({
        new_password: '',
        confirm_new_password: ''
    });
    
    const [roles, setRoles] = useState([]);
    const [message, setMessage] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isPasswordChanging, setIsPasswordChanging] = useState(false);
    const [isAdminPasswordChanging, setIsAdminPasswordChanging] = useState(false);
    const [isPasswordFormOpen, setIsPasswordFormOpen] = useState(false);
    const [isAdminPasswordFormOpen, setIsAdminPasswordFormOpen] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [stripeConnected, setStripeConnected] = useState(false);
    const [stripeConnectedId, setStripeConnectedId] = useState("");

    const stripeAccountId = localStorage.getItem('stripeAccountId');

    const getLogoUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = API_BASE_URL.split('/api')[0];
        return `${baseUrl}${path}`;
    };

    if (stripeAccountId) {
        if (!stripeConnectedId) {
            setStripeConnected(true);
            setStripeConnectedId(stripeAccountId);
        }
    }

    // Check if the current user is an Admin editing themselves
    const isSelfEdit = id && user && parseInt(id) === user.id;
    const isOrgAdminEditor = isSelfEdit && user?.roleName === 'admin';

    useEffect(() => {
        const fetchUserDataAndRoles = async () => {
            try {
                const token = localStorage.getItem('token');
                let userData = {};

                if (!isNew && id) {
                    const userResponse = await axios.get(`${API_BASE_URL}/users/${id}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    userData = userResponse.data;
                }

                if (user?.roleName === 'admin') {
                    const rolesResponse = await axios.get(API_BASE_URL + '/users/roles', {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    setRoles(rolesResponse.data);
                }

                setFormData(prevState => ({
                    ...prevState,
                    ...userData,
                    organization: isOrgAdminEditor ? (user?.organization?.name || '') : (userData.agency || ''),
                    org_address: isOrgAdminEditor ? (user?.organization?.orgAddress || '') : '',
                    role_id: userData.role_id || ''
                }));
            } catch (error) {
                toast.error('Error fetching data. Please check your network and permissions.');
                console.error('Error fetching data:', error);
            }
        };

        if (!isNew && !user) {
            navigate('/login');
            return;
        }
        fetchUserDataAndRoles();
    }, [id, isNew, user?.roleName, navigate, isOrgAdminEditor]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setLogoFile(e.target.files[0]);
        }
    };

    const handleStripeConnect = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axiosClient.get(`/stripe/connect`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data?.url) {
                window.location.href = res.data.url;
            } else {
                toast.error("Unable to start Stripe connection.");
            }
        } catch (err) {
            console.error("Stripe connect error:", err);
            toast.error("Failed to connect Stripe account.");
        }
    };

    const handlePasswordChange = (e) => {
        setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
    };

    const handleAdminPasswordChange = (e) => {
        setAdminPasswordData({ ...adminPasswordData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setMessage(null);
        try {
            const token = localStorage.getItem('token');
            const authHeaders = { headers: { Authorization: `Bearer ${token}` } };

            // 1. Update Organization Details if Admin is editing their own profile
            if (isOrgAdminEditor) {
                await axios.put(`${API_BASE_URL}/users/my-organization`, {
                    name: formData.organization,
                    org_address: formData.org_address
                }, authHeaders);

                let newLogoUrl = user.organization.logoUrl;

                // 2. Upload new logo if selected
                if (logoFile) {
                    const formUpload = new FormData();
                    formUpload.append("logo", logoFile);
                    const logoRes = await axios.post(`${API_BASE_URL}/users/my-organization/logo`, formUpload, {
                        headers: { 
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "multipart/form-data" 
                        },
                    });
                    newLogoUrl = logoRes.data.logo_url;
                }

                // 3. Update localStorage so the new logo & name reflect immediately
                const updatedUser = { ...user };
                updatedUser.organization.name = formData.organization;
                updatedUser.organization.orgAddress = formData.org_address;
                updatedUser.organization.logoUrl = newLogoUrl;
                localStorage.setItem('user', JSON.stringify(updatedUser));
                
                // Triggers a custom event in case TopBar is listening, or force reload if needed
                window.dispatchEvent(new Event("storage")); 
            }

            // 4. Update the actual User Details
            if (isNew) {
                const dataToSubmit = { ...formData };
                await axios.post(API_BASE_URL + '/users/create', dataToSubmit, authHeaders);
                navigate('/users');
            } else {
                await axios.put(`${API_BASE_URL}/users/${id}`, formData, authHeaders);
                toast.success('Profile & Settings updated successfully.');
                
                // Slight delay to allow local storage update to propagate visually
                if (isOrgAdminEditor && logoFile) {
                    setTimeout(() => window.location.reload(), 800);
                }
            }
        } catch (error) {
            toast.error('Failed to save data.');
            console.error('Error saving data:', error);
        } finally {
            setIsSaving(false);
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setIsPasswordChanging(true);
        setMessage(null);
        if (passwordData.new_password !== passwordData.confirm_new_password) {
            toast.error('New passwords do not match.');
            setIsPasswordChanging(false);
            return;
        }
        try {
            const token = localStorage.getItem('token');
            if (!user) throw new Error("User not authenticated.");

            if (user.isContactLogin) {
                await axios.put(`${API_BASE_URL}/users/contact/change-password/${user.contactId}`, passwordData, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            } else {
                await axios.put(`${API_BASE_URL}/users/change-password/${user.id}`, passwordData, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }
            toast.success('Password updated successfully.');
            setPasswordData({ current_password: '', new_password: '', confirm_new_password: '' });
            setIsPasswordFormOpen(false);
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to change password.');
        } finally {
            setIsPasswordChanging(false);
        }
    };

    const handleAdminPasswordSubmit = async (e) => {
        e.preventDefault();
        setIsAdminPasswordChanging(true);
        setMessage(null);
        if (adminPasswordData.new_password !== adminPasswordData.confirm_new_password) {
            toast.error('New passwords do not match.');
            setIsAdminPasswordChanging(false);
            return;
        }
        try {
            const token = localStorage.getItem('token');
            await axios.put(`${API_BASE_URL}/users/reset-password/${id}`, { new_password: adminPasswordData.new_password }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Password updated successfully by admin.');
            setAdminPasswordData({ new_password: '', confirm_new_password: '' });
            setIsAdminPasswordFormOpen(false);
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to reset password.');
        } finally {
            setIsAdminPasswordChanging(false);
        }
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-3xl font-bold text-gray-800 mb-6">
                {isNew ? 'Create New User' : 'User Profile & Settings'}
            </h1>

            <div className="bg-white shadow-lg rounded-lg p-6 mb-6">
                <div className="flex justify-between items-center mb-6 pb-2 border-b">
                    <h2 className="text-xl font-semibold">User Details</h2>
                </div>

                <form onSubmit={handleSubmit}>
                    
                    {/* User Info Fields */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">First Name</label>
                            <input type="text" name="first_name" value={formData.first_name || user.firstName} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Last Name</label>
                            <input type="text" name="last_name" value={formData.last_name || user.lastName} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Email</label>
                            <input type="email" name="email" value={user.isContactLogin ? user.email : formData.email} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">{user.isContactLogin ? "Agency Phone" : "Phone"}</label>
                            <input type="text" name="phone_number" value={formData.phone_number} onChange={handleChange} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                        </div>

                        {user?.roleName === 'admin' && (
                            <>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Role</label>
                                    <select name="role_id" value={formData.role_id || ''} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2">
                                        <option value="">Select a role</option>
                                        {roles.map(role => (
                                            <option key={role.id} value={role.id}>
                                                {role.role_name.replace('_', ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                
                                <div className="relative">
                                    <label className="block text-sm font-medium text-gray-700">Password</label>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        value={formData.password || ""}
                                        onChange={handleChange}
                                        className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2 pr-10"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute right-3 top-[38px] text-gray-500 hover:text-gray-700 focus:outline-none"
                                    >
                                        {showPassword ? <BiHide size={20} /> : <BiShow size={20} />}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>

                    {/* ONLY VISIBLE TO THE ADMIN EDITING THEIR OWN PROFILE */}
                    {isOrgAdminEditor && (
                        <div className="mt-8 pt-6 border-t border-gray-200">
                            <h2 className="text-lg font-semibold text-gray-800 mb-4">Organization Settings</h2>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                {/* Org Name */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Organization / Agency Name</label>
                                    <input type="text" name="organization" value={formData.organization} onChange={handleChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                                </div>

                                {/* Org Address */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Organization Address</label>
                                    <input type="text" name="org_address" value={formData.org_address} onChange={handleChange} placeholder="e.g. 123 Main St, Suite 400" className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                                </div>

                                {/* Org Logo Upload */}
                                <div className="md:col-span-2 mt-2">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Organization Logo</label>
                                    <div className="flex items-center space-x-4 p-3 border rounded-lg bg-gray-50">
                                        {/* Show existing logo if available and no new file selected */}
                                        {user?.organization?.logoUrl && !logoFile && (
                                            <img 
                                                src={getLogoUrl(user.organization.logoUrl)} 
                                                alt="Current Logo" 
                                                className="w-16 h-16 object-contain border rounded bg-white p-1"
                                            />
                                        )}
                                        <div className="flex-1">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleFileChange}
                                                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 cursor-pointer"
                                            />
                                            <p className="text-xs text-gray-400 mt-1">Recommended size: 250x100px. PNG or JPG.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {!user.isContactLogin && (
                        <div className="flex justify-end space-x-4 mt-6 pt-4 border-t">
                            <button type="button" onClick={() => navigate(-1)} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
                                Cancel
                            </button>
                            <button type="submit" disabled={isSaving} className="flex items-center px-6 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
                                <BiSave className="mr-2" /> {isSaving ? 'Saving...' : 'Save Settings'}
                            </button>
                        </div>
                    )}
                </form>
            </div>

            {/* Admin password reset form */}
            {user?.roleName === 'admin' && !isNew && !isSelfEdit && (
                <div className="bg-white shadow-lg rounded-lg p-6 mt-6">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold">Admin Password Reset</h2>
                        <button onClick={() => setIsAdminPasswordFormOpen(!isAdminPasswordFormOpen)} className="text-blue-600 hover:text-blue-800 transition">
                            {isAdminPasswordFormOpen ? 'Close' : 'Reset Password'}
                        </button>
                    </div>
                    {isAdminPasswordFormOpen && (
                        <form onSubmit={handleAdminPasswordSubmit}>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">New Password</label>
                                    <input type="password" name="new_password" value={adminPasswordData.new_password} onChange={handleAdminPasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Confirm New Password</label>
                                    <input type="password" name="confirm_new_password" value={adminPasswordData.confirm_new_password} onChange={handleAdminPasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                                </div>
                            </div>
                            <div className="flex justify-end mt-4">
                                <button type="submit" disabled={isAdminPasswordChanging} className="flex items-center px-4 py-2 bg-red-600 text-white rounded-md text-sm font-medium hover:bg-red-700 disabled:opacity-50">
                                    <BiLock className="mr-2" /> {isAdminPasswordChanging ? 'Resetting...' : 'Reset Password'}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            )}

            {/* Password change form for the user themselves */}
            {isSelfEdit && (
                <div className="bg-white shadow-lg rounded-lg p-6 mt-6">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold">Security: Change Password</h2>
                        <button onClick={() => setIsPasswordFormOpen(!isPasswordFormOpen)} className="text-blue-600 hover:text-blue-800 transition">
                            {isPasswordFormOpen ? 'Close' : 'Change Password'}
                        </button>
                    </div>
                    {isPasswordFormOpen && (
                        <form onSubmit={handlePasswordSubmit}>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Current Password</label>
                                    <input type="password" name="current_password" value={passwordData.current_password} onChange={handlePasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">New Password</label>
                                    <input type="password" name="new_password" value={passwordData.new_password} onChange={handlePasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Confirm New Password</label>
                                    <input type="password" name="confirm_new_password" value={passwordData.confirm_new_password} onChange={handlePasswordChange} required className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-4 focus:ring-indigo-200 block w-full p-2 mt-2" />
                                </div>
                            </div>
                            <div className="flex justify-end mt-4">
                                <button type="submit" disabled={isPasswordChanging} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
                                    <BiKey className="mr-2" /> {isPasswordChanging ? 'Updating...' : 'Update Password'}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            )}

            {/* Admin Stripe Connect */}
            {user?.roleName === 'admin' && isSelfEdit && (
                <div className="bg-blue-50 border border-blue-200 p-5 rounded-lg shadow-sm flex flex-col md:flex-row justify-between items-center mt-6 gap-4">
                    <div>
                        <p className="text-blue-900 font-bold text-lg">Stripe Connect Integration</p>
                        <p className="text-sm text-blue-700 mt-1">
                            {stripeConnected ? `Stripe Account Connected: ${stripeConnectedId}` : "Connect your Stripe account to receive payments securely from your clients."}
                        </p>
                    </div>
                    <button
                        onClick={handleStripeConnect}
                        className="flex items-center whitespace-nowrap bg-blue-600 text-white px-5 py-2.5 rounded-lg shadow-md hover:bg-blue-700 transition"
                    >
                        <BiCreditCard className="mr-2 h-5 w-5" />
                        {stripeConnected ? "Change Stripe Account" : "Connect Stripe"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserForm;